module.exports = __webpack_public_path__ + "static/media/hw_mi_32.b92ec23a.flv";